import { Pipe, PipeTransform } from '@angular/core';
import numeral from 'numeral';

@Pipe({ name: 'hbCustomFormat', pure: true })
export class CustomFormatPipe implements PipeTransform {
  transform(input: any, format: string): any {
    numeral.locale('homebroker-format');

    // This is a patch that will truncate up to the specified precision.
    if (typeof input === 'number') {
      const match = format
        // Remove all the "optional markers": ("0[.]00": optional point), ("0.00[0]": optional third decimal)
        .replace(/[\[\]]/g, '')
        // If the format includes ".0" (as in "$0,000.00"), it'll match
        .match(/.+\.(0+)$/);

      // match[1] contains the string after the "."
      if (match && typeof match[1] === 'string') {
        // This counts the number of zeroes, which is our desired number of decimals
        const zeroes = match[1].length;

        // Reassign the input if it can be truncated, if not, keep the original value
        input = this.truncateToPrecision(input, zeroes) || input;
      }
    }

    if (input !== undefined) {
      /**
       * Numeral.js fails to format numbers outside (1-6, 1e21),
       * apparently http://numbrojs.com/ handles this without us needing
       * to restrict them to that range.
       */
      return numeral(input).format(format);
    } else {
      return input;
    }
  }

  parse(input: any): number {
    const response: any = numeral(input);

    return response.value();
  }

  private truncateToPrecision(input: number, decimals: number) {
    //
    /**
     * This is what truncates the number, and produces a regexp that looks
     * like this (N is the number of decimals):
     *
     * (\d*)\.?(\d{0,N})
     *
     * (\d*)        will match any number digits, including "no digits".
     * \.?          will match ".", but it's optional, to allow integer numbers
     * (\d{0,N})    will match from no-digits ({0,}) up to N digits ({,N})
     *
     * So the expression would be something like:
     *
     * {any number of digits}.{any number of digits, but N at most}
     *
     * Both (\d*) and \.? are to preserve the integer part.
     * The "truncation" happens in (\d{0,N}), because it puts a limit on how
     * many decimals will be included in the regex match.
     *
     * To test it interactively, check: https://regexr.com/
     * And remember to disable the global flag.
     */
    const regexp = new RegExp(`(\\d*)\\.?(\\d{0,${decimals}})`);

    const match = input.toString().match(regexp);

    return Number(match[0]) || undefined;
  }
}
